"use client"

import Header from "@/components/header-group"
import { ComponentConfig } from "@measured/puck"
import { NextIntlClientProvider } from "next-intl"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface HeaderGroupProps extends CommonStylesProps {
  locale: string
}

export const RenderConfig: ComponentConfig<HeaderGroupProps> = {
  render: ({ className, styles, responsiveType, locale }) => {
    const id = `header-group-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const localeToUse = locale || "vi"

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <NextIntlClientProvider locale={localeToUse}>
            <Header locale={localeToUse} />
          </NextIntlClientProvider>
        </div>
      </>
    )
  },
}
